import api from "../api";
import { Modal } from "../ui/components/Modal";

export class ShareModal extends Modal {
    init() {
        this.copyLinkBtn.on("click", this.copyLink.bind(this));
    }

    async setTranscriptionId(id) {
        try {
            const response = await api.post(`${id}/share`);
            this.share_link.element.value = response.data?.public_url || response.public_url ;
            this.copyLinkBtn.disabled = false;
        } catch (error) {
            this.copyLinkBtn.disabled = true;
        }
    }

    copyLink() {
        const link = this.share_link.element.value;
        if (!link || link.includes("Ошибка")) return;

        try {
            this.share_link.element.select();
            const success = document.execCommand('copy');
            
            if (success) {
                this.showCopySuccess();
            }
        } catch (err) {
            console.error("Ошибка копирования", err);
            this.showCopyError();
        }
    }

    showCopySuccess() {
        const originalHtml = this.copyLinkBtn.element.innerHTML;
        this.copyLinkBtn.element.innerHTML = `<i class="bx bx-check me-2"></i> ${this.copy_name}`;
        this.copyLinkBtn.addClass('btn-success');
        this.copyLinkBtn.removeClass('btn-outline-secondary');
        
        setTimeout(() => {
            this.copyLinkBtn.element.innerHTML = originalHtml;
            this.copyLinkBtn.removeClass('btn-success');
            this.copyLinkBtn.addClass('btn-outline-secondary');
        }, 2000);
    }

    showCopyError() {
        const originalHtml = this.copyLinkBtn.element.innerHTML;
        this.copyLinkBtn.addClass('btn-danger');
        this.copyLinkBtn.removeClass('btn-outline-secondary');
        
        setTimeout(() => {
            this.copyLinkBtn.element.innerHTML = originalHtml;
            this.copyLinkBtn.removeClass('btn-danger');
            this.copyLinkBtn.addClass('btn-outline-secondary');
        }, 2000);
    }
}